var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableSimpleBlock',{attrs:{"title":"Fase certificación","items":_vm.officeCertificationReportData,"fields":_vm.fields,"isLoading":_vm.isOfficeCertificationReportLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }